import React from 'react';
import Typography from '@mui/material/Typography';
import { PrismicRichText } from 'common/components/PrismicRichText/PrismicRichText';
import { saasModernTheme } from 'common/theme/saasModern';

const DescriptionComponent = ({ field }) => {
  return (
    <PrismicRichText
      field={field}
      components={{
        paragraph: ({ children }) => (
          <Typography
            sx={(theme) => ({
              fontSize: `${saasModernTheme.space[5]}px`,
              fontWeight: 400,
              fontFamily: saasModernTheme.fontFamily,
              fontStyle: 'normal',
              lineHeight: 'normal',
              color: '#636f81',
              marginTop: saasModernTheme.space[1],
              marginBottom: saasModernTheme.space[1],
              [theme.breakpoints.down('sm')]: {
                fontSize: `${saasModernTheme.space[4]}px`,
                marginTop: '16px',
                marginBottom: '16px',
              },
            })}
          >
            {children}
          </Typography>
        ),
      }}
    />
  );
};

export default DescriptionComponent;
